// extracted by mini-css-extract-plugin
module.exports = {"defaultNotesStyles":"_2M8qef","note":"_34H8yA"};